import * as React from "react";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  AvatarGroup,
  Grid,
  Stack,
  List,
  ListItem,
  ListItemText,
  TextField,
  FormHelperText,
} from "@mui/material";
import { connect } from "react-redux";
import moment from "moment/moment";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/system";

import { createTasks, updateTask } from "store/task/taskactions";
import { Download, LinkOutlined } from "@mui/icons-material";
import { Card, InputAdornment, OutlinedInput, SvgIcon } from "@mui/material";
import { indigo } from "theme/colors";
import Acceptance from "./Acceptance";
import { useFormik } from "formik";
import FileTextInput from "common/FileTextInput";
import { submitproofValidationSchema } from "utils/schema";
import api from "store/api/api";
import { useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  ".MuiDialog-paper": {
    borderRadius: 0,
    minWidth: "35%",
  },
  "& .MuiDialogContent-root": {
    borderTop: `0px solid #F2F4F7`,
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function ViewTask({
  setOpen,
  open,
  type,
  viewID,
  getdata,
  item,
  updateTaskstatus,
}) {
  const [activeStep, setActiveStep] = React.useState(0);
  const navigate = useNavigate();
  const [showErr, setshowErr] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      proof: "",
      url: "",
    },
    validationSchema: submitproofValidationSchema,
    onSubmit: async (values, helpers) => {
      try {
        setLoading(true);
        let formdata = new FormData();
        formdata.append("files", values.proof);
        let submittedurl = await api.post(
          `/assignedTask/uploadFiles/assignedTask/${viewID?._id}`,
          formdata,
        );
        updateTaskstatus(
          {
            submittedUrls: [values.url],
            completionStatus: "done",
            submittedDocuments: submittedurl?.data?.data,
          },
          viewID?._id,
          (e) => {
            setOpen(false);
            getdata();
            setLoading(false);
          },
        );
      } catch (err) {
        setLoading(false);
      }
    },
  });

  const [isloading, setLoading] = React.useState(false);
  const [url, setUrl] = React.useState(
    viewID?.completionStatus == "done" ? viewID?.submittedUrls?.[0] : "",
  );
  const [errors, setError] = React.useState("");
  const [touched, settouch] = React.useState(false);

  const [showCat, setShowCat] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setOpen(false);
      setActiveStep(0);
      setLoading(false);
    }
  };

  const handleUpdate = () => {
    settouch(true);
    if (
      viewID?.completionStatus == "todo" ||
      viewID?.submissionStatus == "notCompleted"
    ) {
      setLoading(true);
      updateTaskstatus(
        {
          completionStatus: "inprogress",
        },
        viewID?._id,
        (ERR) => {
          console.log(ERR);
          if (ERR.err) {
            setshowErr(true);
            getdata();
          } else {
          }
          getdata();

          setShowCat(true);
          setLoading(false);
        },
      );
    }
  };

  React.useEffect(() => {
    formik.resetForm();
  }, [open]);

  const clauseLabel =
    viewID?.task?.clause == "image" || viewID?.task?.taskType == "image"
      ? "Clause 5(A) - Images"
      : viewID?.task?.clause == "video" || viewID?.task?.taskType == "video"
      ? "Clause 5(B) - Videos"
      : viewID?.task?.clause == "ownContent" ||
        viewID?.task?.taskType == "ownContent"
      ? "Clause 5(C) - Own Content"
      : viewID?.task?.clause || viewID?.task?.taskType || "";

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{
            fontSize: "22px",
          }}
        >
          {viewID?.task?.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography variant="smallcontent" gutterBottom>
            {viewID?.task?.description}
          </Typography>
          {clauseLabel && (
            <Stack
              direction={"row"}
              mt={1}
              mb={1}
              justifyContent={"flex-start"}
            >
              <Typography
                color={"#FFA726"}
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                Clause:{" "}
              </Typography>
              <Typography
                color={"#636E72"}
                sx={{
                  fontWeight: "700",
                  fontSize: "12px",
                  marginLeft: "5px",
                }}
              >
                {clauseLabel}
              </Typography>
            </Stack>
          )}
          {(viewID?.task?.department?.name ||
            viewID?.task?.department?.title ||
            viewID?.task?.departmentName) && (
            <Stack
              direction={"row"}
              mt={1}
              mb={1}
              justifyContent={"flex-start"}
            >
              <Typography
                color={"#FFA726"}
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                Department:{" "}
              </Typography>
              <Typography
                color={"#636E72"}
                sx={{
                  fontWeight: "700",
                  fontSize: "12px",
                  marginLeft: "5px",
                }}
              >
                {viewID?.task?.department?.name ||
                  viewID?.task?.department?.title ||
                  viewID?.task?.departmentName}
              </Typography>
            </Stack>
          )}
          <Stack direction={"row"} mt={2} mb={2} justifyContent={"flex-start"}>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={`/img/timer.png`}
                style={{ width: "25px", height: "25px" }}
              />
              <Typography
                color={"#FFA726"}
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  marginLeft: "5px",
                }}
              >
                Deadline:{" "}
              </Typography>
              <Typography
                color={"#636E72"}
                sx={{
                  fontWeight: "700",
                  fontSize: "12px",
                  marginLeft: "5px",
                }}
              >
                {moment(viewID?.task?.endDate).format("DD/MM/YYYY")}{" "}
                {moment(viewID?.task?.endDate).format("hh:mm: a")}
              </Typography>
            </div>
          </Stack>
          <Box mt={2}>
            <Typography variant="bhead">{"Attachment"}</Typography>
          </Box>

          {viewID?.task?.driveLink && (
            <>
              <Typography variant="bhead">{"Drive Link"}</Typography>
              <Typography
                component="a"
                variant="smallcontent"
                href={viewID.task.driveLink}
                target="_blank"
                rel="noreferrer"
                sx={{ display: "block", cursor: "pointer" }}
              >
                {viewID.task.driveLink}
              </Typography>
            </>
          )}
          <List>
            {viewID?.task?.media?.map((file, index) => {
              let it = file?.original?.split("/");
              return (
                <ListItem key={index}>
                  {file?.original?.match(/\.(jpeg|jpg|gif|png|svg)$/i) !=
                    null && (
                    <img
                      src={`${process.env.REACT_APP_IMG}${file?.original}`}
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px",
                      }}
                    ></img>
                  )}
                  <ListItemText secondary={it?.[it?.length - 1]} />

                  <a
                    onClick={() => {
                      window.open(
                        `${process.env.REACT_APP_IMG}${file?.original}`,
                        "_blank",
                      );
                    }}
                  >
                    <Download />
                  </a>
                </ListItem>
              );
            })}
          </List>
          <form noValidate onSubmit={formik.handleSubmit}>
            {viewID?.task?.taskType !== "ownContent" &&
              (viewID?.completionStatus == "inprogress" ||
                viewID?.submissionStatus == "notCompleted") && (
                <Box mt={2}>
                  <Typography variant="bhead" gutterBottom>
                    {"Upload Url"}
                  </Typography>
                  <OutlinedInput
                    fullWidth
                    disabled={
                      viewID?.completionStatus == "done" &&
                      viewID?.submissionStatus != "notCompleted"
                    }
                    sx={{ mt: 1 }}
                    name={"url"}
                    placeholder="Upload link"
                    onChange={(e) =>
                      formik.setFieldValue("url", e.target.value)
                    }
                    value={
                      viewID?.completionStatus == "done" &&
                      viewID?.submissionStatus != "notCompleted"
                        ? url
                        : formik.values.url
                    }
                    error={formik.touched.url ? formik.errors.url : ""}
                    startAdornment={
                      <InputAdornment position="start">
                        <SvgIcon color={indigo.main} fontSize="small">
                          <LinkOutlined />
                        </SvgIcon>
                      </InputAdornment>
                    }
                  />
                  {formik.touched.url && (
                    <FormHelperText className="text-danger" mt={1} ml="1">
                      {formik.errors.url}
                    </FormHelperText>
                  )}
                </Box>
              )}

            {viewID?.task?.taskType === "ownContent" &&
              viewID?.submissionStatus == "documentApproved" && (
                <Box mt={2}>
                  <Typography variant="bhead" gutterBottom>
                    {"Upload Url"}
                  </Typography>
                  <OutlinedInput
                    fullWidth
                    disabled={
                      viewID?.completionStatus == "done" &&
                      viewID?.submissionStatus != "notCompleted"
                    }
                    sx={{ mt: 1 }}
                    name={"url"}
                    placeholder="Upload link"
                    onChange={(e) =>
                      formik.setFieldValue("url", e.target.value)
                    }
                    value={
                      viewID?.completionStatus == "done" &&
                      viewID?.submissionStatus != "notCompleted"
                        ? url
                        : formik.values.url
                    }
                    error={formik.touched.url ? formik.errors.url : ""}
                    startAdornment={
                      <InputAdornment position="start">
                        <SvgIcon color={indigo.main} fontSize="small">
                          <LinkOutlined />
                        </SvgIcon>
                      </InputAdornment>
                    }
                  />
                  {formik.touched.url && (
                    <FormHelperText className="text-danger" mt={1} ml="1">
                      {formik.errors.url}
                    </FormHelperText>
                  )}
                </Box>
              )}
            {viewID?.completionStatus == "done" &&
              viewID?.submissionStatus != "notCompleted" && (
                <Box mt={2}>
                  <Typography variant="bhead" gutterBottom>
                    {"Upload Url"}
                  </Typography>
                  <OutlinedInput
                    fullWidth
                    disabled={true}
                    sx={{ mt: 1 }}
                    name={"url"}
                    placeholder="Upload link"
                    onChange={(e) =>
                      formik.setFieldValue("url", e.target.value)
                    }
                    value={viewID?.submittedUrls?.[0]}
                    //    error={formik.touched.url ? formik.errors.url : ""}
                    startAdornment={
                      <InputAdornment position="start">
                        <SvgIcon color={indigo.main} fontSize="small">
                          <LinkOutlined />
                        </SvgIcon>
                      </InputAdornment>
                    }
                  />
                </Box>
              )}

            {viewID?.task?.taskType !== "ownContent" &&
              (viewID?.completionStatus == "inprogress" ||
                viewID?.submissionStatus == "notCompleted") && (
                <Box mt={2}>
                  <Typography variant="bhead" gutterBottom>
                    {"Upload Proof (Screenshot of post)"}
                  </Typography>
                  <FileTextInput
                    type="file"
                    placeholder="Upload File"
                    name="proof"
                    required
                    bottomSpace
                    onChange={formik}
                    value={formik.values.proof}
                    error={formik.touched.proof ? formik.errors.proof : ""}
                  />
                  <Box sx={{ marginLeft: "4px", marginBottom: 2 }}>
                    <Typography variant="h7">
                      {"  "} Note: All files should less than 250 MB
                    </Typography>
                  </Box>
                </Box>
              )}

            {viewID?.task?.taskType === "ownContent" &&
              viewID?.submissionStatus == "documentApproved" && (
                <Box mt={2}>
                  <Typography variant="bhead" gutterBottom>
                    {"Upload Proof (Screenshot of post)"}
                  </Typography>
                  <FileTextInput
                    type="file"
                    placeholder="Upload File"
                    name="proof"
                    required
                    bottomSpace
                    onChange={formik}
                    value={formik.values.proof}
                    error={formik.touched.proof ? formik.errors.proof : ""}
                  />
                  <Box sx={{ marginLeft: "4px", marginBottom: 2 }}>
                    <Typography variant="h7">
                      {"  "} Note: All files should less than 250 MB
                    </Typography>
                  </Box>
                </Box>
              )}

            {viewID?.submissionStatus == "notCompleted" && (
              <Stack
                direction={"row"}
                mt={2}
                mb={2}
                justifyContent={"flex-start"}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    color={"red"}
                    sx={{
                      fontWeight: "bold",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    Note:{" "}
                  </Typography>
                  <Typography
                    color={"#636E72"}
                    sx={{
                      fontWeight: "700",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {viewID.note}
                  </Typography>
                </div>
              </Stack>
            )}
            {viewID?.completionStatus == "done" &&
              viewID?.submissionStatus != "notCompleted" && (
                <Stack
                  direction={"row"}
                  mt={2}
                  mb={2}
                  justifyContent={"flex-start"}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      color={"#219653"}
                      sx={{
                        fontWeight: "bold",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      Submitted On:{" "}
                    </Typography>
                    <Typography
                      color={"#636E72"}
                      sx={{
                        fontWeight: "700",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {moment(viewID?.submittedOn).format("DD/MM/YYYY")}{" "}
                      {moment(viewID?.submittedOn).format("hh:mm: a")}
                    </Typography>
                  </div>
                </Stack>
              )}
            {viewID?.submissionStatus == "documentApprovalPending" && (
              <Typography variant="bhead" color={"orangered"} gutterBottom>
                Submitted content is under review
              </Typography>
            )}
            {viewID?.submissionStatus == "documentRevise" && (
              <Typography variant="bhead" color={"red"} gutterBottom>
                Submitted content Need to be revised
              </Typography>
            )}
            <Grid
              container
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              mt={4}
            >
              {viewID?.completionStatus == "todo" && (
                // moment(viewID?.task?.endDate).isAfter(moment()) &&
                <LoadingButton
                  onClick={handleUpdate}
                  variant="contained"
                  loading={isloading}
                  sx={{ width: "200px", alignSelf: "center" }}
                >
                  Accept Task{" "}
                </LoadingButton>
              )}

              {viewID?.task?.taskType == "ownContent" &&
                viewID?.submissionStatus != "documentApprovalPending" &&
                viewID?.submissionStatus != "documentRevise" &&
                viewID?.submissionStatus != "documentApproved" &&
                viewID?.completionStatus == "inprogress" &&
                moment(viewID?.task?.endDate).isAfter(moment()) && (
                  <LoadingButton
                    onClick={() => {
                      navigate(`/owncontent?taskId=${viewID?._id}&open=true`);
                    }}
                    variant="contained"
                    loading={isloading}
                    sx={{ width: "200px", alignSelf: "center" }}
                  >
                    Create Content{" "}
                  </LoadingButton>
                )}
              {viewID?.task?.taskType !== "ownContent" &&
                viewID?.completionStatus == "inprogress" &&
                moment(viewID?.task?.endDate).isAfter(moment()) && (
                  <LoadingButton
                    onClick={handleUpdate}
                    variant="contained"
                    type="submit"
                    loading={isloading}
                    sx={{ width: "200px", alignSelf: "center" }}
                  >
                    {viewID?.completionStatus == "todo"
                      ? "Start task"
                      : "Submit"}
                  </LoadingButton>
                )}

              {viewID?.task?.taskType === "ownContent" &&
                viewID?.submissionStatus == "documentApproved" &&
                moment(viewID?.task?.endDate).isAfter(moment()) && (
                  <LoadingButton
                    onClick={handleUpdate}
                    variant="contained"
                    type="submit"
                    loading={isloading}
                    sx={{ width: "200px", alignSelf: "center" }}
                  >
                    {"Submit"}
                  </LoadingButton>
                )}
              {viewID?.submissionStatus == "notCompleted" && (
                <LoadingButton
                  variant="contained"
                  type="submit"
                  loading={isloading}
                  sx={{ width: "200px", alignSelf: "center" }}
                >
                  {"Submit"}
                </LoadingButton>
              )}
              <LoadingButton
                onClick={handleClose}
                sx={{ width: "200px", alignSelf: "center" }}
              >
                Close
              </LoadingButton>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions></DialogActions>
        <Acceptance
          viewID={viewID}
          setOpen={() => {
            handleClose();
            setShowCat(false);
          }}
          err={showErr}
          open={showCat}
        />
      </BootstrapDialog>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  updateTaskstatus: (data, id, callback) =>
    dispatch(updateTask(data, id, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ViewTask);
